import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Шрифты (self-hosted variable): Onest — весь интерфейс (текст, заголовки, цифры); JetBrains Mono — только
// машинные идентификаторы (IdText). См. docs/design-guidelines.md.
import '@fontsource-variable/onest';
import '@fontsource-variable/jetbrains-mono';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import './styles/global.css';
import './i18n';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
